import { render, staticRenderFns } from "./LotList.vue?vue&type=template&id=bf4a23da&"
import script from "./LotList.vue?vue&type=script&lang=js&"
export * from "./LotList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports